module.exports = __webpack_public_path__ + "static/media/PostgreSQL.780b0e47.png";